import { SlashCommand } from './types';

export const askFliptCommands: SlashCommand[] = [
    { id: 'flashcards', name: 'Generate Flashcards', trigger: '/flashcards', description: 'Create study flashcards', category: 'Productivity', icon: 'fa-clone', mode: 'workflow', prefix: 'generate flashcards for: ', integration: 'AskFlipt' },
    { id: 'quiz', name: 'Generate Quiz', trigger: '/quiz', description: 'Create an interactive quiz', category: 'Productivity', icon: 'fa-clipboard-question', mode: 'workflow', prefix: 'generate a quiz for: ', integration: 'AskFlipt' }
];
